import { get } from "../methods";
function getMarketSummaries(market, industry) {
  return get({
    url: "getMarketSummaries",
    baseURL: "https://swr.simplywall.st/",
    payload: {
      market,
      industry
    }
  });
}
export {
  getMarketSummaries as default
};
